import React, { useState, useEffect } from 'react';
import { Card, Descriptions, Spin, message, Button, Table, Tag } from 'antd';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeftOutlined } from '@ant-design/icons';
import CopyableText from '../../components/CopyableText';
import { formatDateTime } from '../../utils/format';
import { getBlock } from '../../services/explorerService';

const BlockDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [block, setBlock] = useState(null);
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadBlockDetail = async () => {
    setLoading(true);
    try {
      const data = await getBlock(id);
      setBlock(data.block);
      setTransactions(data.transactions || []);
    } catch (error) {
      message.error('加载区块详情失败');
      console.error('Block detail error:', error);
    }
    setLoading(false);
  };

  useEffect(() => {
    loadBlockDetail();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const txColumns = [
    {
      title: '交易哈希',
      dataIndex: 'txid',
      key: 'txid',
      render: (text) => (
        <a 
          href="#"
          onClick={(e) => {
            e.preventDefault();
            navigate(`/dashboard/explorer/transaction/${text}`);
          }}
        >
          <CopyableText text={text} />
        </a>
      )
    },
    {
      title: '费用',
      dataIndex: 'fee',
      key: 'fee',
      render: (fee) => fee ? parseFloat(fee).toFixed(8) : '-'
    },
    {
      title: '状态',
      dataIndex: 'is_mined',
      key: 'is_mined',
      render: (mined) => (
        <Tag color={mined ? 'green' : 'orange'}>
          {mined ? '已确认' : '未确认'}
        </Tag>
      )
    }
  ];

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '100px 0' }}>
        <Spin size="large" />
      </div>
    );
  }

  if (!block) {
    return (
      <Card>
        <p>区块不存在</p>
        <Button onClick={() => navigate('/dashboard/explorer')}>返回浏览器</Button>
      </Card>
    );
  }

  return (
    <div>
      <div style={{ marginBottom: 16 }}>
        <Button icon={<ArrowLeftOutlined />} onClick={() => navigate(-1)}>
          返回
        </Button>
      </div>

      <Card title="区块详情" style={{ marginBottom: 16 }}>
        <Descriptions column={1} bordered>
          <Descriptions.Item label="区块高度">{block.height}</Descriptions.Item>
          <Descriptions.Item label="区块哈希">
            <CopyableText text={block.hash} />
          </Descriptions.Item>
          <Descriptions.Item label="前区块哈希">
            <CopyableText text={block.prev_hash} />
          </Descriptions.Item>
          <Descriptions.Item label="Merkle Root">
            <CopyableText text={block.merkle_root} />
          </Descriptions.Item>
          <Descriptions.Item label="总难度">{block.total_difficulty || '-'}</Descriptions.Item>
          <Descriptions.Item label="所属链">{block.chain_name}</Descriptions.Item>
          <Descriptions.Item label="时间">
            {formatDateTime(block.inserted_at)}
          </Descriptions.Item>
        </Descriptions>
      </Card>

      <Card title={`交易列表 (${transactions.length})`}>
        {transactions.length > 0 ? (
          <Table
            columns={txColumns}
            dataSource={transactions}
            rowKey="id"
            pagination={false}
          />
        ) : (
          <p style={{ textAlign: 'center', color: '#999' }}>暂无交易</p>
        )}
      </Card>
    </div>
  );
};

export default BlockDetail;
